import { addSpacesAndCapitalizeAllWords } from './Formats';

const saveAccount = (
  createAccount,
  updateAccount,
  householdId,
  type,
) => (account) => {
  if (!account.id) {
    const acct = account;
    acct.type = 'account';
    acct.attributes.accountType = type;
    return new Promise((resolve, reject) => {
      createAccount(householdId, acct)
        .then(res => resolve(res.data[0]))
        .catch(err => reject(err));
    });
  }
  return new Promise((resolve, reject) => {
    updateAccount(householdId, account.id, account)
      .then(res => resolve(res.data[0]))
      .catch(err => reject(err));
  });
};

export const logicalBalance = (accountResource) => {
  if (accountResource.attr('accountType') === 'liability') {
    return (-1 * parseFloat(accountResource.attr('balance')) || 0);
  }
  if (accountResource.attr('type') === 'realAsset') {
    return (parseFloat(accountResource.attr('value')) || 0);
  }
  return (parseFloat(accountResource.attr('balance')) || 0);
};

export const displayName = (accountResource) => {
  if (accountResource.attr('name')) {
    return accountResource.attr('name');
  }
  if (accountResource.attr('institution')) {
    return addSpacesAndCapitalizeAllWords(`${accountResource.attr('institution')} - ${accountResource.attr('type')}`);
  }
  return addSpacesAndCapitalizeAllWords(accountResource.attr('type'));
};

export default saveAccount;
